import React from 'react';
import { Button, Label } from 'nhsuk-react-components';
import './exportDisclaimer.css';

const ExportDisclaimer = ({ isOpen, message, onYes, onNo }) => {
    if (!isOpen) return null;

    return (
        <>
            <div className="modal-overlay">
                <div className="modal">
                    <div className="modal-header">
                        <h2>Are you sure you want to extract this data?</h2>
                    </div>
                    <div className="modal-body">
                        <Label>{message}</Label>
                    </div>
                    <div className="modal-footer">
                        <Button
                            onClick={onYes}
                            className="nhsuk-button nhsuk-button--primary margin-bottom-0"
                        >
                            Yes
                        </Button>
                        <Button
                            onClick={onNo}
                            className="nhsuk-button nhsuk-button--secondary margin-bottom-0"
                        >
                            No
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExportDisclaimer;
